var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContent1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1283.44,
    height: 216.64,
    viewBox: "0 0 1283.44 216.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g_3533",
    "data-name": "g 3533",
    transform: "translate(-307.56 -1891.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_1485",
    "data-name": "path 1485",
    d: "M14.04-4.32v-62.4L1.56-65.04V-78L25.32-88.08H36.6V-4.32Z",
    transform: "translate(306 1981)",
    fill: "silver",
    opacity: 0.649
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\uB3CC\\uBD04_\\uD6C4_\\uD788\\uC5B4\\uB85C_\\uC120\\uC0DD\\uB2D8\\uC774_\\uC9C1\\uC811_\\uC544\\uC774\\uC758_\\uAE30\\uBD84_\\uAC74\\uAC15_\\uBC1C\\uB2EC\\uC0C1\\uD0DC\\uB97C_\\uAE30\\uB85D\\uD558\\uC5EC_\\uC544\\uC774\\uC758_\\uC131\\uC7A5\\uC744_\\uB3C4\\uC640\\uC918\\uC694",
    "data-name": "\\uB3CC\\uBD04 \\uD6C4 \\uD788\\uC5B4\\uB85C \\uC120\\uC0DD\\uB2D8\\uC774 \\uC9C1\\uC811 \\uC544\\uC774\\uC758 \\uAE30\\uBD84, \\uAC74\\uAC15, \\uBC1C\\uB2EC\\uC0C1\\uD0DC\\uB97C \\uAE30\\uB85D\\uD558\\uC5EC \\uC544\\uC774\\uC758 \\uC131\\uC7A5\\uC744 \\uB3C4\\uC640\\uC918\\uC694",
    transform: "translate(848 2025)",
    fill: "#484848",
    fontSize: 18,
    fontFamily: "NotoSansCJKkr-Light, Noto Sans CJK KR",
    fontWeight: 300,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uB3CC\uBD04 \uD6C4 \uD788\uC5B4\uB85C \uC120\uC0DD\uB2D8\uC774 \uC9C1\uC811"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26
  }, "\uC544\uC774\uC758 \uAE30\uBD84, \uAC74\uAC15, \uBC1C\uB2EC\uC0C1\uD0DC\uB97C"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 52
  }, "\uAE30\uB85D\uD558\uC5EC \uC544\uC774\uC758 \uC131\uC7A5\uC744 \uB3C4\uC640\uC918\uC694")), /*#__PURE__*/React.createElement("text", {
    id: "\\uC544\\uC774\\uC758_\\uC77C\\uC0C1\\uC744_\\uAE30\\uB85D\\uD574\\uC694_",
    "data-name": "\\uC544\\uC774\\uC758 \\uC77C\\uC0C1\\uC744 \\uAE30\\uB85D\\uD574\\uC694!",
    transform: "translate(848 1933)",
    fontSize: 20,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC544\uC774\uC758 \uC77C\uC0C1\uC744 \uAE30\uB85D\uD574\uC694!")), /*#__PURE__*/React.createElement("text", {
    id: "\\uD788\\uC5B4\\uB85C_\\uB180\\uC774\\uC5F0\\uAD6C\\uC18C\\uC5D0\\uC11C_\\uAC1C\\uBC1C\\uD55C_1000\\uAC00\\uC9C0_\\uD788\\uC5B4\\uB85C_\\uB180\\uC774\\uBC95\\uC744_\\uD65C\\uC6A9\\uD558\\uC5EC_\\uC544\\uC774\\uC758_\\uC5F0\\uB839_\\uC131\\uD5A5_\\uBC1C\\uB2EC_\\uB2E8\\uACC4\\uC5D0_\\uB9DE\\uCD98_\\uD765\\uBBF8\\uB85C\\uC6B4_\\uB180\\uC774\\uB97C_\\uC9C4\\uD589\\uD574\\uC694",
    "data-name": "\\uD788\\uC5B4\\uB85C \\uB180\\uC774\\uC5F0\\uAD6C\\uC18C\\uC5D0\\uC11C \\uAC1C\\uBC1C\\uD55C 1000\\uAC00\\uC9C0 \\uD788\\uC5B4\\uB85C \\uB180\\uC774\\uBC95\\uC744 \\uD65C\\uC6A9\\uD558\\uC5EC \\uC544\\uC774\\uC758 \\uC5F0\\uB839/\\uC131\\uD5A5/\\uBC1C\\uB2EC \\uB2E8\\uACC4\\uC5D0 \\uB9DE\\uCD98 \\uD765\\uBBF8\\uB85C\\uC6B4 \\uB180\\uC774\\uB97C \\uC9C4\\uD589\\uD574\\uC694",
    transform: "translate(377 2025)",
    fill: "#484848",
    fontSize: 18,
    fontFamily: "NotoSansCJKkr-Light, Noto Sans CJK KR",
    fontWeight: 300,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uD788\uC5B4\uB85C \uB180\uC774\uC5F0\uAD6C\uC18C\uC5D0\uC11C \uAC1C\uBC1C\uD55C"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26
  }, "1000\uAC00\uC9C0 \uD788\uC5B4\uB85C \uB180\uC774\uBC95\uC744 \uD65C\uC6A9\uD558\uC5EC"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 52
  }, "\uC544\uC774\uC758 \uC5F0\uB839/\uC131\uD5A5/\uBC1C\uB2EC \uB2E8\uACC4\uC5D0 \uB9DE\uCD98"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 78,
    xmlSpace: "preserve"
  }, "\uD765\uBBF8\uB85C\uC6B4 \uB180\uC774\uB97C \uC9C4\uD589\uD574\uC694")), /*#__PURE__*/React.createElement("text", {
    id: "\\uC990\\uAC81\\uAC8C_\\uB180\\uBA74\\uC11C_\\uBC30\\uC6CC\\uC694_",
    "data-name": "\\uC990\\uAC81\\uAC8C \\uB180\\uBA74\\uC11C \\uBC30\\uC6CC\\uC694!",
    transform: "translate(377 1933)",
    fontSize: 20,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC990\uAC81\uAC8C \uB180\uBA74\uC11C \uBC30\uC6CC\uC694!")), /*#__PURE__*/React.createElement("text", {
    id: "\\uC544\\uC774\\uAC00_\\uC798_\\uB3C4\\uCC29\\uD588\\uB294\\uC9C0_\\uAC71\\uC815\\uB418\\uB294_\\uBD80\\uBAA8\\uB2D8\\uC758_\\uB9C8\\uC74C\\uC744_\\uC548\\uC2EC\\uC2DC\\uD0A4\\uAE30_\\uC704\\uD574_\\uB4F1\\uD558\\uC6D0_\\uB4F1\\uD558\\uAD50_\\uC0C1\\uD669\\uC744_\\uC2E4\\uC2DC\\uAC04\\uC73C\\uB85C_\\uC54C\\uB824\\uB4DC\\uB824\\uC694",
    "data-name": "\\uC544\\uC774\\uAC00 \\uC798 \\uB3C4\\uCC29\\uD588\\uB294\\uC9C0 \\uAC71\\uC815\\uB418\\uB294 \\uBD80\\uBAA8\\uB2D8\\uC758 \\uB9C8\\uC74C\\uC744 \\uC548\\uC2EC\\uC2DC\\uD0A4\\uAE30 \\uC704\\uD574 \\uB4F1\\uD558\\uC6D0/\\uB4F1\\uD558\\uAD50 \\uC0C1\\uD669\\uC744 \\uC2E4\\uC2DC\\uAC04\\uC73C\\uB85C  \\uC54C\\uB824\\uB4DC\\uB824\\uC694",
    transform: "translate(1302 2025)",
    fill: "#484848",
    fontSize: 18,
    fontFamily: "NotoSansCJKkr-Light, Noto Sans CJK KR",
    fontWeight: 300,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC544\uC774\uAC00 \uC798 \uB3C4\uCC29\uD588\uB294\uC9C0 \uAC71\uC815\uB418\uB294"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26
  }, "\uBD80\uBAA8\uB2D8\uC758 \uB9C8\uC74C\uC744 \uC548\uC2EC\uC2DC\uD0A4\uAE30 \uC704\uD574"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 52
  }, "\uB4F1\uD558\uC6D0/\uB4F1\uD558\uAD50 \uC0C1\uD669\uC744 \uC2E4\uC2DC\uAC04\uC73C\uB85C "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 78
  }, "\uC54C\uB824\uB4DC\uB824\uC694")), /*#__PURE__*/React.createElement("text", {
    id: "\\uC2E4\\uC2DC\\uAC04\\uC73C\\uB85C_\\uC54C\\uB824\\uC918\\uC694_",
    "data-name": "\\uC2E4\\uC2DC\\uAC04\\uC73C\\uB85C \\uC54C\\uB824\\uC918\\uC694!",
    transform: "translate(1302 1932)",
    fontSize: 20,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC2E4\uC2DC\uAC04\uC73C\uB85C \uC54C\uB824\uC918\uC694!")), /*#__PURE__*/React.createElement("path", {
    id: "path_1484",
    "data-name": "path 1484",
    d: "M4.56-4.92V-17.64L15.48-29.52q7.44-7.92,11.28-12.42a85.9,85.9,0,0,0,7.56-10.5q3.72-6,3.72-9.96,0-6.24-3.78-8.52T22.92-73.2q-6.72,0-15.6,3.84L5.52-84.84q9.48-4.8,24.84-4.8,30.6,0,30.6,23.88a24.044,24.044,0,0,1-.6,5.22,28.524,28.524,0,0,1-1.8,5.4q-1.2,2.7-2.46,5.16a38.47,38.47,0,0,1-3.24,5.16q-1.98,2.7-3.3,4.56a55.149,55.149,0,0,1-3.54,4.38q-2.22,2.52-3.18,3.6t-2.82,3.06q-1.86,1.98-1.98,2.1l-5.52,5.88H60V-4.92Z",
    transform: "translate(757 1981)",
    fill: "silver",
    opacity: 0.649
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_1483",
    "data-name": "path 1483",
    d: "M29.64-3.6a67.9,67.9,0,0,1-15-1.68Q7.2-6.96,3.36-9.36l3-15.12a28.053,28.053,0,0,0,8.46,2.88,51.247,51.247,0,0,0,10.5,1.2q13.8,0,13.8-10.8,0-4.8-3.48-6.66t-10.2-2.22l-8.52-.36V-54.96l7.32-.24A23.279,23.279,0,0,0,34.5-58.02a7.272,7.272,0,0,0,3.9-6.54q0-8.4-13.32-8.4A48.351,48.351,0,0,0,9.24-70.44L7.08-86.04q8.04-3.6,24.6-3.6,12.72,0,20.58,5.34t7.86,15.54q0,14.64-14.04,19.8,16.44,2.88,16.44,19.92,0,12.12-8.82,18.78T29.64-3.6Z",
    transform: "translate(1208 1981)",
    fill: "silver",
    opacity: 0.649
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\uC804\\uBB38_1:1_\\uB180\\uC774\\uB3CC\\uBD04",
    "data-name": "\\uC804\\uBB38 1:1 \\uB180\\uC774\\uB3CC\\uBD04",
    transform: "translate(377 1974)",
    fontSize: 28,
    fontFamily: "NotoSansCJKkr-Bold, Noto Sans CJK KR",
    fontWeight: 700,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC804\uBB38 1:1 \uB180\uC774\uB3CC\uBD04")), /*#__PURE__*/React.createElement("text", {
    id: "\\uD788\\uC5B4\\uB85C_\\uC131\\uC7A5\\uB178\\uD2B8",
    "data-name": "\\uD788\\uC5B4\\uB85C \\uC131\\uC7A5\\uB178\\uD2B8",
    transform: "translate(848 1974)",
    fontSize: 28,
    fontFamily: "NotoSansCJKkr-Bold, Noto Sans CJK KR",
    fontWeight: 700,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uD788\uC5B4\uB85C \uC131\uC7A5\uB178\uD2B8")), /*#__PURE__*/React.createElement("text", {
    id: "\\uB4F1\\uD558\\uC6D0_\\uB4F1\\uD558\\uAD50_\\uBCF4\\uACE0_\\uC2DC\\uC2A4\\uD15C",
    "data-name": "\\uB4F1\\uD558\\uC6D0/\\uB4F1\\uD558\\uAD50 \\uBCF4\\uACE0 \\uC2DC\\uC2A4\\uD15C",
    transform: "translate(1302 1974)",
    fontSize: 28,
    fontFamily: "NotoSansCJKkr-Bold, Noto Sans CJK KR",
    fontWeight: 700,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uB4F1\uD558\uC6D0/\uB4F1\uD558\uAD50 \uBCF4\uACE0 \uC2DC\uC2A4\uD15C")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent1);
export default __webpack_public_path__ + "static/media/content1.852cff97.svg";
export { ForwardRef as ReactComponent };